<template>
    <div class="resultCard">
        <div class="chat__group">
            <div v-for="(text, i) in resultCardData" :key="i" class="chat__item">
                <Card :text="text" />
            </div>
            <div class="resultCard__information chat__item">
                <div class="resultCard__headline">{{ $t('result:headline') }}</div>
                <div class="resultCard__label">
                    <div class="resultCard__text">{{ $t('result:text') }}</div>
                    <div class="resultCard__result">
                        <span class="resultCard__unit">{{ $t('general:chf') }} </span>
                        <span class="resultCard__value">{{ formattedAmount }}</span>
                    </div>
                </div>
                <img class="resultCard__image" alt="result" :src="require(`@/assets/images/web_icons/${text.image}.svg`)"/>
                <div class="resultCard__desc">
                    <p>{{ $t(`result:description:text1:${text.resultText}`) }}</p>
                </div>
                <div class="resultCard__base">{{ $t('result:base') }}</div>
            </div>
            <div class="resultCard__action chat__item">
                <button id="goToResult" class="btn btn-carbon"
                    @click="handleSecureIncome"
                    @keyup.enter="handleSecureIncome">{{ $t('result:secure') }}</button>
                <button id="reCalculateResult" class="btn btn-grey"
                    @click="handleCalculation"
                    @keyup.enter="handleCalculation">{{ $t('result:calculate') }}</button>
            </div>
        </div>
        <template v-if="show">
            <div v-if="cardOne" class="teaser chat__group">
                <div v-for="(text, i) in details.cardText" :key="i" class="slide-up-active">
                    <Card :text="text"/>
                </div>
                <div class="teaser__content slide-up-active">
                    <div class="teaser__heading">{{ details.header }}</div>
                    <div class="teaser__subHeading">{{ details.subHeader }}</div>
                    <p class="teaser__text">{{ details.text }}</p>
                    <div class="teaser__conatiner">
                        <div class="teaser__title">{{ details.body.title }}</div>
                        <ul class="teaser__desc">
                            <li v-for="(help, i) in details.body.description" :key="i">{{ help }}</li>
                        </ul>
                    </div>
                    <button
                        class="btn btn-carbon"
                        @click="openContactForm = !openContactForm"
                        @keyup.enter="openContactForm = !openContactForm"
                        >
                        {{ details.action }}
                    </button>
                </div>
            </div>
            <div v-else class="teaser chat__group">
                <div v-for="(text, i) in details.cardText" :key="i" class="slide-up-active">
                    <Card :text="text"/>
                </div>
                <carousel v-if="details.body" :per-page="1" :perPageCustom="[[768, 1]]" class="slide-up-active custom_carousel" :navigationEnabled="true">
                    <slide class="slide_1">
                        <Tile>
                            <template #header>
                                {{ details.body.cardOne.title }}
                            </template>
                            <div slot="content" v-html="details.body.cardOne.description"/>
                            <template #footer>
                            <div class="btn-panel">
                                <a :href="details.body.cardOne.learnMore.link.url" class="btn btn-white" target='_blank' rel="noopener" @click="onLinkClicked">
                                    {{ details.body.cardOne.learnMore.link.title }}
                                </a>
                                <button
                                    class="btn btn-carbon"
                                    @click="openContactForm = !openContactForm"
                                    @keyup.enter="openContactForm = !openContactForm"
                                    >
                                    {{ details.body.cardOne.appointment }}
                                </button>
                            </div>
                            </template>
                        </Tile>
                    </slide>
                    <slide class="slide_2">
                        <Tile>
                            <template #header>
                                {{ details.body.cardTwo.title }}
                                </template>
                                <div slot="content" v-html="details.body.cardTwo.description"/>
                                <template #footer>
                                <div class="btn-panel">
                                    <a :href="details.body.cardTwo.learnMore.link.url" class="btn btn-white" target='_blank' rel="noopener" @click="onLinkClicked">
                                        {{ details.body.cardTwo.learnMore.link.title }}
                                    </a>
                                    <button
                                        class="btn btn-carbon"
                                        @click="openContactForm = !openContactForm"
                                        @keyup.enter="openContactForm = !openContactForm"
                                        >
                                        {{ details.body.cardTwo.appointment }}
                                    </button>
                                </div>
                            </template>
                        </Tile>
                    </slide>
                    <slide class="slide_3">
                        <Tile>
                            <template #header>
                            {{ details.body.cardThree.title }}
                            </template>
                            <div slot="content" v-html="details.body.cardThree.description"/>
                        </Tile>
                    </slide>
                </carousel>
            </div>
            <Modal
                name="contact-us"
                class="modal-layout-override contact-us-modal personal-info"
                :open="openContactForm"
                @close="openContactForm = false"
                >
                <template #header>
                    <span class="personal-info__heading">{{
                    $t("contactUs:clientInformation.heading")
                    }}</span>
                </template>
                <template #content>
                    <ContactUs @close="openContactForm = false"/>
                </template>
            </Modal>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Card from '@/components/Card'
import Tile from '@/components/layout/Tile'
import { Carousel, Slide } from 'vue-carousel'
import Modal from '@/components/layout/Modal'
import ContactUs from '@/views/Contact-Us'
import adobeTracking from '@/mixins/adobeTracking'

export default {
    name: 'ResultCard',
    components: { Card, Tile, Carousel, Slide, Modal, ContactUs },
    data() {
        return {
            show: false,
            openContactForm: false
        }
    },
    mixins: [
        adobeTracking
    ],
    computed: {
        ...mapGetters('question', [
            'values',
            'result',
            'text'
        ]),
        resultCardData: {
            get() {
                return this.$t('result:cardText', { returnObjects: true })
            }
        },
        formattedAmount() {
            return new Intl.NumberFormat('de-CH').format(this.result)
        },
        cardOne() {
            return (this.result >= 5000)
        },
        details() {
            return this.$t(`infoDetails:${this.cardOne ? 'maxValue' : 'minValue'}`, { returnObjects: true })
        }
    },
    methods: {
        ...mapActions('question', [
            'goToQuestion'
        ]),
        handleSecureIncome() {
            this.show = true
            setTimeout(() => {
                this.$emit('showResult', document.querySelector('.teaser'))
            }, 1000)
            this.trackFormStep('showResult')
        },
        handleCalculation() {
            this.$emit('calculateResult', 1)
            this.trackFormStep('reCalculateResult')
        },
        onLinkClicked(e) {
            this.trackCTAClick({
                CTAName: e.target.innerText,
                CTALink: e.target.href
            })
        }
    },
    mounted() {
        document.getElementById('goToResult').focus()
    }
}
</script>
